export enum EventStatus {
    PENDING = 'PENDING',
    CREATING = 'CREATING',
    CREATED = 'CREATED',
    INACTIVE = 'INACTIVE'
}
